module.exports = __webpack_public_path__ + "img/em8.e894c836.jpg";